import './InsuranceOption.css';

const InsuranceOption = ({ icon, title, description, price, link, selected, onChange, onReadMore }) => {
  const handleLinkClick = (e) => {
    e.preventDefault();
    if (onReadMore) {
      onReadMore();
    }
  };

  return (
    <div className={`insurance-option ${selected ? 'selected' : ''}`}>
      <div className="insurance-icon">{icon}</div>
      <div className="insurance-info">
        <h4>{title}</h4>
        <p>{description}</p>
        {link && (
          <button 
            onClick={handleLinkClick} 
            className="read-more"
          >
            {link.text}
          </button>
        )}
      </div>
      <div className="insurance-price">{price}</div>
      <input 
        type="checkbox" 
        checked={selected}
        onChange={onChange}
        className="insurance-checkbox"
      />
    </div>
  );
};

export default InsuranceOption;
